import {
    Evaluation,
    BasicEvaluationType,
} from '@api/evaluation';

export class PatientEvaluation {
    id: number;
    creationDate: number;
    typeEvaluation: BasicEvaluationType;
    height: number;
    weight: Evaluation;
}

export class PatientFullEvaluation {
    id: number;
    creationDate: number;
    evaluationType: BasicEvaluationType;
    height: EvaluationData;
    weight: EvaluationData;
    kgMA: EvaluationData;
    kgMM: EvaluationData;
    kgMO: EvaluationData;
    kgMP: EvaluationData;
    kgMR: EvaluationData;
}

export class EvaluationData {
    value: number;
    indicator: string;
}
